import { FlexibleListDirectionalModel } from '@services/flexible_component/mod';
import { HStack, VStack, Text } from '@visiba-cortex/react-ui-std';
import { FlexibleIdentifier } from './flexible_identifier.component';
import { FONT_VARIANT } from '../../constants';
import styled from 'styled-components';

interface Props {
	component: FlexibleListDirectionalModel;
}

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
	`,
};

export function FlexibleListDirectional({ component }: Props): JSX.Element {
	const children = component.items.map((item) => <FlexibleIdentifier key={item.id} component={item} />);

	return (
		<elements.container data-testid='FlexibleListDirectional'>
			{component.title && <Text font={FONT_VARIANT.SMALL_BODY}>{component.title}</Text>}
			{component.direction === 'Horizontal' && <HStack>{children}</HStack>}
			{component.direction === 'Vertical' && <VStack>{children}</VStack>}
		</elements.container>
	);
}
